import { render, staticRenderFns } from "./MasterProductMerkSelect.vue?vue&type=template&id=60dd5605&"
import script from "./MasterProductMerkSelect.vue?vue&type=script&lang=ts&"
export * from "./MasterProductMerkSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60dd5605')) {
      api.createRecord('60dd5605', component.options)
    } else {
      api.reload('60dd5605', component.options)
    }
    module.hot.accept("./MasterProductMerkSelect.vue?vue&type=template&id=60dd5605&", function () {
      api.rerender('60dd5605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/MasterProductMerkSelect.vue"
export default component.exports